import React from "react";
import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";
import { FaGavel } from "react-icons/fa";
import { motion } from "framer-motion";
import { margin } from "@mui/system";
import "../Services.css"; // Assuming you have a CSS file for styles

function AIGovernance() {
  // รายการบริการ
  const services = [
    {
      title: "บริการงานตรวจสอบภายใน",
      desc: "การตรวจสอบภายในช่วยให้มั่นใจว่ากระบวนการทำงานเป็นไปตามมาตรฐานและกฎหมายที่เกี่ยวข้อง",
      img: require("../../../image/services/internal-audit.webp"),
    },
    {
      title: "บริการงานประเมินระบบการควบคุมภายใน (IPO)",
      desc: "มุ่งเน้นการสร้างความเชื่อมั่นในข้อมูลทางการเงินและการดำเนินงานของบริษัท",
      img: require("../../../image/services/ipo.webp"),
    },
    {
      title:
        "บริการงานประเมินตนเองเกี่ยวกับมาตรการต่อต้านทุจริตคอร์รัปชัน (CAC)",
      desc: "ช่วยให้บริษัทสามารถประเมินและปรับปรุงมาตรการป้องกันการทุจริตได้อย่างมีประสิทธิภาพ",
      img: require("../../../image/services/cac.webp"),
    },
    {
      title: "บริการงานสอบทานคุณภาพงานตรวจสอบภายใน (QAR)",
      desc: "มุ่งมั่นในการยกระดับมาตรฐานการตรวจสอบภายในขององค์กรคุณ",
      img: require("../../../image/services/qar.webp"),
    },
    {
      title: "บริการงานประเมินระบบ IT",
      desc: "การตรวจสอบระบบ IT ที่มุ่งเน้นการประเมินความเสี่ยงและการควบคุมภายใน เพื่อให้มั่นใจว่าระบบ IT ขององค์กรมีความปลอดภัยและเชื่อถือได้",
      img: require("../../../image/services/it-audit.webp"),
    },
    {
      title: "บริการงานพัฒนาระบบ",
      desc: "วางรากฐานและพัฒนาระบบงานที่ใช่ ตอบโจทย์ธุรกิจในวันนี้และอนาคต",
      img: require("../../../image/services/system-development.webp"),
    },
    {
      title: "บริการงานพัฒนาธุรกิจ",
      desc: "ปลดล็อกศักยภาพและสร้างการเติบโตอย่างยั่งยืนให้ธุรกิจของคุณ",
      img: require("../../../image/services/business-development.webp"),
    },
    {
      title: "บริการงานตรวจสอบพิเศษ",
      desc: "ค้นหาความจริงและปกป้ององค์กรของคุณเมื่อมีสัญญาณการทุจริต",
      img: require("../../../image/services/special-audit.webp"),
    },
    {
      title: "บริการรายงาน ESG",
      desc: "สร้างความยั่งยืนให้ธุรกิจและตอบสนองความคาดหวังของนักลงทุนยุคใหม่",
      img: require("../../../image/services/esg-reporting.webp"),
    },
    {
      title: "บริการ Due Diligence",
      desc: "ตัดสินใจลงทุนอย่างมั่นใจ ลดความเสี่ยงที่ไม่คาดคิด ด้วยข้อมูลเชิงลึกรอบด้าน",
      img: require("../../../image/services/due-diligence.webp"),
    },
    {
      title: "บริการรายงาน Carbon Footprint",
      desc: "วัดผลและบริหารจัดการการปล่อยก๊าซเรือนกระจก เพื่อก้าวสู่ธุรกิจคาร์บอนต่ำ",
      img: require("../../../image/services/carbon-footprint.webp"),
    },
    {
      title: "บริการที่ปรึกษาจัดตั้งหน่วยงานตรวจสอบภายใน",
      desc: "สร้างหน่วยงานตรวจสอบภายในที่แข็งแกร่งและเปี่ยมประสิทธิภาพจากจุดเริ่มต้น",
      img: require("../../../image/services/in-house.webp"),
    },
    {
      title: "บริการการกำกับดูแลและจัดการการใช้งานเทคโนโลยีปัญญาประดิษฐ์",
      desc: "ควบคุมความเสี่ยงและปลดล็อกคุณค่าจาก AI ด้วยกรอบการกำกับดูแลที่รัดกุม",
      img: require("../../../image/services/ai-governance.webp"),
    },
    {
      title: "บริการประเมินความพร้อมการกำกับดูแลปัญญาประดิษฐ์",
      desc: "สำรวจความพร้อมและวางแผนการเดินทางสู่การกำกับดูแล AI ที่มีประสิทธิภาพ",
      img: require("../../../image/services/ai-gra.webp"),
    },
  ];

  // สุ่มเลือก 3 รายการ โดยไม่รวมบริการของหน้าปัจจุบัน
  function getRandomServices(arr, n, excludeTitle) {
    const filtered = arr.filter((s) => s.title !== excludeTitle);
    const shuffled = filtered.slice().sort(() => 0.5 - Math.random());
    return shuffled.slice(0, n);
  }
  const randomServices = getRandomServices(
    services,
    3,
    "บริการการกำกับดูแลและจัดการการใช้งานเทคโนโลยีปัญญาประดิษฐ์"
  );

  return (
    <div
      style={{
        background: "#f8f9fa",
        minHeight: "100vh",
        paddingTop: 0,
        paddingBottom: 48,
        fontFamily: "Prompt, sans-serif",
      }}
    >
      <section
        className="hero-section"
        style={{
          fontFamily: "Prompt, sans-serif",
          background: `linear-gradient(rgba(30, 30, 30, 0.2), rgba(30,30,30,0.2)), url(${require("../../../image/services/ai-governance.webp")}) center center/cover no-repeat`,
        }}
      >
        <div className="hero-content">
          <h1
            className="hero-title"
            style={{ marginTop: "80px", color: "rgba(255, 75, 75, 1)" }}
          >
            {" "}
            บริการการกำกับดูแลและจัดการการใช้งานเทคโนโลยีปัญญาประดิษฐ์
          </h1>
          <p
            className="hero-subtitle"
            style={{ color: "rgba(255, 255, 255, 1)" }}
          >
            ควบคุมความเสี่ยงและปลดล็อกคุณค่าจาก AI ด้วยกรอบการกำกับดูแลที่รัดกุม
          </p>
        </div>
      </section>
      {/* Breadcrumbs Section - Red Tone */}
      <Container fluid="md" style={{ marginTop: 0 }}>
        <Row className="justify-content-center">
          <Col xs={120} md={110} lg={100} xl={90} xxl={80}>
            <motion.nav
              aria-label="breadcrumb"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              style={{ marginBottom: 0 }}
            >
              <ol
                className="breadcrumb"
                style={{
                  background: "rgba(255, 255, 255, 1)",
                  borderRadius: 14,
                  padding: "12px 24px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  display: "flex",
                  gap: 8,
                  fontSize: 16,
                  fontWeight: 500,
                  marginBottom: 0,
                  alignItems: "center",
                  flexWrap: "wrap",
                  border: "1px solid #ffffffff",
                }}
              >
                <motion.li
                  className="breadcrumb-item"
                  whileHover={{ scale: 1.08, color: "#848484ff" }}
                  style={{ transition: "0.2s", marginRight: 4 }}
                >
                  <a
                    href="/"
                    style={{
                      color: "#848484ff",
                      textDecoration: "none",
                      fontWeight: 600,
                    }}
                  >
                    <span style={{ marginRight: 4, fontSize: 18 }}></span>
                    หน้าแรก
                  </a>
                </motion.li>
                <span
                  style={{ color: "#848484ff", fontSize: 20, margin: "0 4px" }}
                >
                  ›
                </span>
                <motion.li
                  className="breadcrumb-item"
                  whileHover={{ scale: 1.08, color: "#848484ff" }}
                  style={{ transition: "0.2s", marginRight: 4 }}
                >
                  <a
                    href="/services"
                    style={{
                      color: "#848484ff",
                      textDecoration: "none",
                      fontWeight: 600,
                    }}
                  >
                    <span style={{ marginRight: 4, fontSize: 20 }}></span>
                    บริการของเรา
                  </a>
                </motion.li>
                <span
                  style={{ color: "#ffb3b3", fontSize: 18, margin: "0 4px" }}
                >
                  ›
                </span>
                <motion.li
                  className="breadcrumb-item"
                  whileHover={{ scale: 1.08, color: "#848484ff" }}
                  style={{ transition: "0.2s", marginRight: 4 }}
                >
                  <a
                    href="/services"
                    style={{
                      color: "#ff7070ff",
                      textDecoration: "none",
                      fontWeight: 600,
                    }}
                  >
                    <span style={{ marginRight: 4, fontSize: 20 }}></span>
                    บริการการกำกับดูแลและจัดการการใช้งานเทคโนโลยีปัญญาประดิษฐ์
                  </a>
                </motion.li>
              </ol>
            </motion.nav>
          </Col>
        </Row>
      </Container>
      <Container fluid="md">
        <Row className="justify-content-center" style={{ marginTop: 24 }}>
          <Col xs={120} md={110} lg={100} xl={90} xxl={80}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
            >
              <Card
                className="border-0 shadow-sm"
                style={{ borderRadius: 18, background: "#fff" }}
              >
                <Card.Body style={{ padding: 40, marginBottom: 32 }}>
                  <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.7, delay: 0.2 }}
                    className="d-flex align-items-center mb-3"
                  >
                    <FaGavel className="me-2" color=" #db3b3bff" size={28} />
                    <h2
                      className="fw-bold mb-0"
                      style={{ fontSize: 28, letterSpacing: 0.5 }}
                    >
                      บริการการกำกับดูแลและจัดการการใช้งานเทคโนโลยีปัญญาประดิษฐ์
                    </h2>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.7, delay: 0.4 }}
                    className="mb-4"
                    style={{
                      background: "#f3f4f6",
                      borderRadius: 12,
                      padding: 20,
                      marginBottom: 32,
                    }}
                  >
                    <blockquote
                      className="mb-0"
                      style={{
                        fontSize: 16,
                        color: "#555",
                        fontStyle: "italic",
                        borderLeft: "4px solid #db3b3bff",
                        paddingLeft: 16,
                      }}
                    >
                      "นำพาองค์กรของคุณสู่ยุค AI อย่างมั่นใจและมีธรรมาภิบาล"
                    </blockquote>
                  </motion.div>
                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.6 }}
                    className="mb-4"
                    style={{ fontSize: 17, color: "#222", lineHeight: 1.7 }}
                  >
                    เทคโนโลยีปัญญาประดิษฐ์ (AI)
                    กำลังเข้ามามีบทบาทในโลกธุรกิจอย่างรวดเร็ว
                    แต่ในขณะเดียวกันก็นำมาซึ่งความเสี่ยงใหม่ๆ
                    ทั้งในด้านความถูกต้องของข้อมูล, ความเป็นส่วนตัว,
                    ความลำเอียง, และความปลอดภัย การมีกรอบการกำกับดูแล AI (AI
                    Governance) ที่ดี จะช่วยให้องค์กรของคุณสามารถนำ AI
                    มาใช้ประโยชน์ได้อย่างเต็มศักยภาพ
                    โดยยังคงสามารถบริหารจัดการความเสี่ยงที่เกี่ยวข้องได้อย่างมีประสิทธิภาพ
                  </motion.p>
                  <hr className="my-4" style={{ opacity: 0.15 }} />
                  <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.7 }}
                    className="mb-4"
                  >
                    <h4
                      className="fw-semibold mb-4 d-flex align-items-center"
                      style={{ color: "#db3b3bff", fontSize: 20 }}
                    >
                      <span className="me-2" role="img" aria-label="service">
                        📝
                      </span>{" "}
                      ขอบเขตการบริการของเรา
                    </h4>

                    {/* Service Item 1 */}
                    <div
                      className="mb-4"
                      style={{
                        background:
                          "linear-gradient(135deg, #fff5f5 0%, #fef2f2 100%)",
                        borderRadius: 8,
                        padding: 24,
                        border: "1px solid #ffffffff",
                        boxShadow: "0 4px 12px rgba(255, 255, 255, 0.08)",
                      }}
                    >
                      <h5
                        className="fw-bold mb-3 d-flex align-items-center"
                        style={{ color: "#dc2626", fontSize: 18 }}
                      >
                        <span
                          className="me-2"
                          style={{
                            background: "#dc2626",
                            color: "white",
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          1
                        </span>
                        การพัฒนากรอบการกำกับดูแล AI
                      </h5>
                      <ul
                        className="mb-0"
                        style={{ paddingLeft: 20, color: "#374151" }}
                      >
                        <li className="mb-2">
                          ช่วยกำหนดหลักการ, นโยบาย,
                          และโครงสร้างความรับผิดชอบในการพัฒนาและใช้งาน AI
                          ภายในองค์กร
                        </li>
                        <li className="mb-0">
                          ยกร่าง "นโยบายการใช้งาน AI อย่างมีจริยธรรม" (Ethical
                          AI Policy)
                        </li>
                      </ul>
                    </div>

                    {/* Service Item 2 */}
                    <div
                      className="mb-4"
                      style={{
                        background:
                          "linear-gradient(135deg, #fff5f5 0%, #fef2f2 100%)",
                        borderRadius: 8,
                        padding: 24,
                        border: "1px solid #ffffffff",
                        boxShadow: "0 4px 12px rgba(255, 255, 255, 0.08)",
                      }}
                    >
                      <h5
                        className="fw-bold mb-3 d-flex align-items-center"
                        style={{ color: "#dc2626", fontSize: 18 }}
                      >
                        <span
                          className="me-2"
                          style={{
                            background: "#dc2626",
                            color: "white",
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          2
                        </span>
                        การประเมินและบริหารจัดการความเสี่ยงจาก AI
                      </h5>
                      <ul
                        className="mb-0"
                        style={{ paddingLeft: 20, color: "#374151" }}
                      >
                        <li className="mb-2">
                          ช่วยระบุและประเมินความเสี่ยงที่อาจเกิดขึ้นจากการใช้โมเดล
                          AI ในด้านต่างๆ
                        </li>
                        <li className="mb-0">
                          ให้คำแนะนำในการออกแบบการควบคุมเพื่อลดความเสี่ยงเหล่านั้น
                        </li>
                      </ul>
                    </div>

                    {/* Service Item 3 */}
                    <div
                      className="mb-4"
                      style={{
                        background:
                          "linear-gradient(135deg, #fff5f5 0%, #fef2f2 100%)",
                        borderRadius: 8,
                        padding: 24,
                        border: "1px solid #ffffffff",
                        boxShadow: "0 4px 12px rgba(255, 255, 255, 0.08)",
                      }}
                    >
                      <h5
                        className="fw-bold mb-3 d-flex align-items-center"
                        style={{ color: "#dc2626", fontSize: 18 }}
                      >
                        <span
                          className="me-2"
                          style={{
                            background: "#dc2626",
                            color: "white",
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          3
                        </span>
                        การสร้างความโปร่งใสและสามารถอธิบายได้ (Transparency &
                        Explainability)
                      </h5>
                      <ul
                        className="mb-0"
                        style={{ paddingLeft: 20, color: "#374151" }}
                      >
                        <p className="mb-0">
                          ให้คำปรึกษาในการจัดทำเอกสารประกอบโมเดล AI
                          เพื่อให้สามารถอธิบายการตัดสินใจของ AI ได้
                        </p>
                      </ul>
                    </div>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0 }}
                    className="mb-4"
                  >
                    <h4
                      className="fw-semibold mb-3 d-flex align-items-center"
                      style={{
                        color: "#db3b3bff",
                        fontSize: 24,
                        marginTop: 48,
                      }}
                    >
                      <span className="me-2" role="img" aria-label="price">
                        💸
                      </span>{" "}
                      ทำไมต้องเลือกบริการกฎหมายธุรกิจจากเรา?
                    </h4>
                    <ListGroup variant="flush">
                      <ListGroup.Item
                        style={{
                          background: "none",
                          border: 0,
                          paddingLeft: 0,
                          color: "#444",
                        }}
                      >
                        <span className="fw-bold"></span>
                      </ListGroup.Item>
                      <ListGroup.Item
                        style={{
                          background: "none",
                          border: 0,
                          paddingLeft: 0,
                          color: "#444",
                        }}
                      >
                        เราเป็นผู้เชี่ยวชาญที่ผสมผสานความรู้ความเข้าใจในด้านเทคโนโลยี,
                        การบริหารความเสี่ยง, และการกำกับดูแลกิจการเข้าด้วยกัน
                        เราสามารถช่วยคุณสร้างสมดุลระหว่างการส่งเสริมนวัตกรรมและการควบคุมความเสี่ยง
                        เพื่อให้การเดินทางสู่โลกของ AI
                        ขององค์กรคุณเป็นไปอย่างมั่นคงและรับผิดชอบ
                      </ListGroup.Item>
                    </ListGroup>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0 }}
                  >
                    <hr
                      style={{
                        border: "none",
                        borderTop: "2px solid #e0e0e0",
                        margin: "32px 0 24px 0",
                        marginBottom: "32px",
                        opacity: 0.7,
                      }}
                    />
                    <h4
                      className="fw-semibold mb-3 d-flex align-items-center"
                      style={{ color: "#db3b3bff", fontSize: 20 }}
                    >
                      <span className="me-2" role="img" aria-label="related">
                        🔗
                      </span>{" "}
                      บริการอื่นๆ
                    </h4>
                    <Row xs={1} md={3} className="g-3">
                      {randomServices.map((service, idx) => {
                        // กำหนดลิงก์สำหรับแต่ละบริการ
                        let link = "#";
                        switch (service.title) {
                          case "บริการงานตรวจสอบภายใน":
                            link = "/services/internal-audit";
                            break;
                          case "บริการงานประเมินระบบการควบคุมภายใน (IPO)":
                            link = "/services/ipo";
                            break;
                          case "บริการงานประเมินตนเองเกี่ยวกับมาตรการต่อต้านทุจริตคอร์รัปชัน (CAC)":
                            link = "/services/cac";
                            break;
                          case "บริการงานสอบทานคุณภาพงานตรวจสอบภายใน (QAR)":
                            link = "/services/aqr";
                            break;
                          case "บริการงานประเมินระบบ IT":
                            link = "/services/it-audit";
                            break;
                          case "บริการงานพัฒนาระบบ":
                            link = "/services/system-development";
                            break;
                          case "บริการงานตรวจสอบพิเศษ":
                            link = "/services/special-audit";
                            break;
                          case "บริการรายงาน ESG":
                            link = "/services/esg-reporting";
                            break;
                          case "บริการ Due Diligence":
                            link = "/services/due-diligence";
                            break;
                          case "บริการรายงาน Carbon Footprint":
                            link = "/services/carbon-footprint";
                            break;
                          case "บริการที่ปรึกษาจัดตั้งหน่วยงานตรวจสอบภายใน":
                            link = "/services/internal-audit";
                            break;
                          case "บริการการกำกับดูแลและจัดการการใช้งานเทคโนโลยีปัญญาประดิษฐ์":
                            link = "/services/ai-governance";
                            break;
                          case "บริการประเมินความพร้อมการกำกับดูแลปัญญาประดิษฐ์":
                            link = "/services/ai-governance";
                            break;
                          default:
                            link = "#";
                        }
                        return (
                          <Col key={idx}>
                            <a href={link} style={{ textDecoration: "none" }}>
                              <Card
                                className="h-100 shadow-sm card-hover"
                                style={{
                                  borderRadius: 18,
                                  background: `linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(220,38,38,0.08) 100%), url(${service.img}) center center/cover no-repeat`,
                                  border: "none",
                                  minHeight: 240,
                                  color: "#fff",
                                  position: "relative",
                                  boxShadow: "0 6px 24px rgba(220,38,38,0.10)",
                                  transition: "transform 0.2s, box-shadow 0.2s",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform =
                                    "translateY(-6px) scale(1.03)";
                                  e.currentTarget.style.boxShadow =
                                    "0 12px 32px rgba(220,38,38,0.18)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = "none";
                                  e.currentTarget.style.boxShadow =
                                    "0 6px 24px rgba(220,38,38,0.10)";
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    background: "rgba(98, 98, 98, 0.5)",
                                    borderRadius: 18,
                                    zIndex: 1,
                                  }}
                                ></div>
                                <Card.Body
                                  style={{
                                    position: "relative",
                                    zIndex: 2,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                  }}
                                >
                                  <Card.Title
                                    style={{
                                      color: "#ec3e3eff",
                                      fontWeight: 700,
                                      fontSize: 20,
                                      textAlign: "center",
                                      marginBottom: 12,
                                      letterSpacing: 0.5,
                                      textShadow:
                                        "0 2px 8px rgba(220,38,38,0.08)",
                                    }}
                                  >
                                    {service.title
                                      .split("\n")
                                      .map((line, idx) => (
                                        <React.Fragment key={idx}>
                                          {line}
                                          <br />
                                        </React.Fragment>
                                      ))}
                                  </Card.Title>
                                  <Card.Text
                                    style={{
                                      color: "#dcdcdcff",
                                      fontSize: 16,
                                      textAlign: "center",
                                      fontWeight: 500,
                                      lineHeight: 1.6,
                                    }}
                                  >
                                    {service.desc}
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            </a>
                          </Col>
                        );
                      })}
                    </Row>
                  </motion.div>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AIGovernance;
